import axios from "axios";
import { useAppStore } from "@/stores/appStore";

const apiAxios = axios.create({
  timeout: 1000 * 30,
});

class ApiError extends Error {
  constructor(message) {
    super(message);
    this.name = "ApiError";
  }
}

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

apiAxios.interceptors.request.use(async (config) => {
  const store = useAppStore();

  config.metadata = { startTime: new Date() };

  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
  } else {
    config.headers["Content-Type"] = "application/json";
  }

  let accessToken = store.accessToken;

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

apiAxios.interceptors.response.use(
  (response) => {
    // const store = useAppStore();

    // const endTime = new Date();
    // const duration = endTime - response.config.metadata.startTime;

    // // let url = response.config.url.replace("https://", "").split(".pec.com.tw");
    // let url = "";
    // if (response.config.url.includes(".pec.com.tw")) {
    //   // 正式環境
    //   url = response.config.url.replace("https://", "").split(".pec.com.tw");
    // } else {
    //   // 地端開發
    //   url = response.config.url;
    // }

    // let afltp = "";
    // // if (store.userId && response.config.data) {
    // //   afltp = JSON.parse(response.config.data).url || "";
    // // }

    // store.setAPIStatus([
    //   url[0],
    //   afltp ? afltp.split("api")[1] : url[1].split("/api")[1],
    //   response.config.metadata.startTime,
    //   endTime,
    //   (duration / 1000).toFixed(2),
    // ]);

    if (response.config.baseURL == process.env.VUE_APP_LEAVE_API) {
      return response.data;
    } else {
      if (response.data.status && response.data.status != 1) {
        return Promise.reject(
          new ApiError(response.data.result.result_message)
        );
      } else {
        return response.data;
      }
    }
  },
  (error) => {
    if (error.code === "ECONNABORTED" && error.message.includes("timeout")) {
      return Promise.reject(new ApiError("Request timeout"));
    }

    const store = useAppStore();
    const { config, response } = error;
    const originalRequest = config;
    if (response) {
      if (response.status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true;
          store
            .refreshAccessToken()
            .then((newToken) => {
              store.setToken(newToken);
              onAccessTokenFetched(newToken.access_token);
            })
            .catch(() => {
              store.logout();
              subscribers = [];
            })
            .finally(() => {
              isAlreadyFetchingAccessToken = false;
            });
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber((accessToken) => {
            originalRequest.headers.Authorization = "Bearer " + accessToken;
            resolve(axios(originalRequest).then((res) => res.data));
          });
        });
        return retryOriginalRequest;
      } else if (response.status === 419) {
        // 離職、登出
        store.logout();
        return Promise.reject(new ApiError("您已離職"));
      } else if (response.status === 403) {
        return Promise.reject(new ApiError("權限不足"));
      } else if (response.status === 404) {
        return Promise.reject(new ApiError("錯誤路徑"));
      } else if (response.status === 422) {
        return Promise.reject(new ApiError(error.response.data.message));
      } else if (response.status === 500) {
        return Promise.reject(new ApiError("server 錯誤"));
      } else if (response.status > 500 && response.status < 600) {
        return Promise.reject(
          new ApiError(`發生不可預期錯誤: ${response.status}`)
        );
      } else {
        return Promise.reject(error.response.data.message);
      }
    } else {
      if (!window.navigator.onLine) {
        return Promise.reject(new ApiError("無網路連線"));
      } else {
        return Promise.reject(new ApiError("資料存取錯誤"));
      }
    }
  }
);

function onAccessTokenFetched(accessToken) {
  subscribers = subscribers.filter((callback) => callback(accessToken));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

export { apiAxios, ApiError };
